import script from "./BuildMonitor.vue?vue&type=script&setup=true&lang=js"
export * from "./BuildMonitor.vue?vue&type=script&setup=true&lang=js"

import "./BuildMonitor.vue?vue&type=style&index=0&id=2bace58a&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/boeingdl-dev-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bace58a"]])

export default __exports__